import { motion } from "framer-motion";
import { SectionTitle } from "@/components/shared/SectionTitle";
import { AddressCopy } from "@/components/shared/AddressCopy";
import { ADDRESSES } from "@/lib/contracts";

export function ContractAddressesSection() {
  return (
    <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-4xl px-4">
        <SectionTitle
          subtitle="TRANSPARENCY"
          title="Contract Addresses"
          description="All contracts are deployed and verified on Robinhood Chain (chainId 4663)."
          centered
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-10 grid gap-4 sm:grid-cols-2"
        >
          <AddressCopy label="$CATCLAW" address={ADDRESSES.CATCLAW} />
          <AddressCopy label="Cat Claw NFT" address={ADDRESSES.CatStonks} />
          <AddressCopy label="Cat Claw Rounds" address={ADDRESSES.CatStonksRounds} />
          <AddressCopy label="Cat Claw Vault" address={ADDRESSES.CatStonksVault} />
        </motion.div>
      </div>
    </section>
  );
}
